import { DocumentMeta, listDocuments, subscribeDocumentsIndex } from '@/persistence/local'
import { useEffect, useState } from 'react'

export function useDocumentsIndex(): DocumentMeta[] {
  const [documents, setDocuments] = useState<DocumentMeta[]>(() => listDocuments())

  useEffect(() => {
    // Initialize and subscribe to changes
    setDocuments(listDocuments())
    const unsub = subscribeDocumentsIndex(() => {
      setDocuments(listDocuments())
    })
    return () => unsub()
  }, [])

  return documents
}

